<template>
  <section class="ceo-section">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-lg-4 col-md-5 col-12 text-center">
          <div class="ceo-photo-wrapper">
            <img class="ceo-photo" :src="ceoImage" alt="CEO Creativa360" />
          </div>
        </div>

        <div class="col-lg-8 col-md-7 col-12">
          <div class="ceo-content">

            <span class="ceo-badge">{{ $t('ceo.badge') }}</span>
            <h2 class="ceo-name">{{ ceoName }}</h2>

            <p class="ceo-summary">
              {{ $t('ceo.summary') }}
            </p>

            <button class="ceo-toggle-btn" @click="isOpen = !isOpen">
              <span>
                {{ isOpen ? $t('ceo.hide') : $t('ceo.show') }}
              </span>
              <i class="bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
            </button>

            <transition name="fade-slide">
              <div v-if="isOpen" class="ceo-details">
                <div v-for="(job, idx) in ceoExperience" :key="idx" class="ceo-exp-card">

                  <div class="ceo-exp-header">
                    <div class="ceo-exp-role">{{ $t(job.puesto) }}</div>
                    <div class="ceo-exp-company">{{ $t(job.empresa) }}</div>
                  </div>

                  <div class="ceo-exp-meta">
                    <span class="ceo-exp-dates">{{ $t(job.fecha) }}</span>
                    <span class="ceo-exp-sep">•</span>
                    <span class="ceo-exp-loc">{{ $t(job.ubicacion) }}</span>
                  </div>

                  <div class="ceo-exp-desc">
                    <p v-for="(line, i) in job.descripcion" :key="i">
                      {{ $t(line) }}
                    </p>
                  </div>

                </div>
              </div>
            </transition>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CeoSection',
  data() {
    return {
      ceoImage: require('@/assets/img/resources/lover2.png'),

      ceoName: 'Michel Conesa',

      ceoExperience: [
        {
          puesto: 'ceo.exp1.role',
          empresa: 'ceo.exp1.company',
          fecha: 'ceo.exp1.date',
          ubicacion: 'ceo.exp1.location',
          descripcion: [
            'ceo.exp1.d1','ceo.exp1.d2','ceo.exp1.d3','ceo.exp1.d4','ceo.exp1.d5'
          ]
        },
        {
          puesto: 'ceo.exp2.role',
          empresa: 'ceo.exp2.company',
          fecha: 'ceo.exp2.date',
          ubicacion: 'ceo.exp2.location',
          descripcion: [
            'ceo.exp2.d1','ceo.exp2.d2','ceo.exp2.d3','ceo.exp2.d4','ceo.exp2.d5'
          ]
        },
        {
          puesto: 'ceo.exp3.role',
          empresa: 'ceo.exp3.company',
          fecha: 'ceo.exp3.date',
          ubicacion: 'ceo.exp3.location',
          descripcion: [
            'ceo.exp3.d1','ceo.exp3.d2','ceo.exp3.d3','ceo.exp3.d4'
          ]
        },
        {
          puesto: 'ceo.exp4.role',
          empresa: 'ceo.exp4.company',
          fecha: 'ceo.exp4.date',
          ubicacion: 'ceo.exp4.location',
          descripcion: [
            'ceo.exp4.d1','ceo.exp4.d2','ceo.exp4.d3','ceo.exp4.d4'
          ]
        },
        {
          puesto: 'ceo.exp5.role',
          empresa: 'ceo.exp5.company',
          fecha: 'ceo.exp5.date',
          ubicacion: 'ceo.exp5.location',
          descripcion: [
            'ceo.exp5.d1','ceo.exp5.d2','ceo.exp5.d3','ceo.exp5.d4'
          ]
        },
        {
          puesto: 'ceo.exp6.role',
          empresa: 'ceo.exp6.company',
          fecha: 'ceo.exp6.date',
          ubicacion: 'ceo.exp6.location',
          descripcion: [
            'ceo.exp6.d1','ceo.exp6.d2','ceo.exp6.d3'
          ]
        },
        {
          puesto: 'ceo.exp7.role',
          empresa: 'ceo.exp7.company',
          fecha: 'ceo.exp7.date',
          ubicacion: 'ceo.exp7.location',
          descripcion: [
            'ceo.exp7.d1','ceo.exp7.d2','ceo.exp7.d3'
          ]
        },
        {
          puesto: 'ceo.exp8.role',
          empresa: 'ceo.exp8.company',
          fecha: 'ceo.exp8.date',
          ubicacion: 'ceo.exp8.location',
          descripcion: [
            'ceo.exp8.d1','ceo.exp8.d2','ceo.exp8.d3'
          ]
        },
        {
          puesto: 'ceo.exp9.role',
          empresa: 'ceo.exp9.company',
          fecha: 'ceo.exp9.date',
          ubicacion: 'ceo.exp9.location',
          descripcion: [
            'ceo.exp9.d1','ceo.exp9.d2','ceo.exp9.d3','ceo.exp9.d4','ceo.exp9.d5','ceo.exp9.d6','ceo.exp9.d7'
          ]
        }
      ],
      isOpen: false
    };
  }
};
</script>

<style scoped>
/* ====== Layout general ====== */
.ceo-section {
  background: #ffffff;
  padding: 60px 0;
  color: #1a1a1d;
  font-family: inherit;
}

.ceo-photo-wrapper {
  display: inline-block;
  background: #f5f5f5;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
  max-width: 260px;
  width: 100%;
}

.ceo-photo {
  width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
  display: block;
}

/* ====== Contenido textual ====== */
.ceo-content {
  margin-top: 20px;
}

.ceo-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  background: #1a1a1d;
  color: #fff;
  padding: 4px 10px;
  border-radius: 999px;
  line-height: 1.3;
  margin-bottom: 12px;
}

.ceo-name {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1d;
  margin: 0 0 12px;
}

.ceo-summary {
  font-size: 15px;
  line-height: 1.6;
  color: #444;
  margin-bottom: 20px;
  max-width: 620px;
}

/* ====== Botón toggle ====== */
.ceo-toggle-btn {
  background: linear-gradient(90deg, #5d0e02 0%, #f43939 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  line-height: 1.2;
  box-shadow: 0 4px 10px rgba(225, 110, 30, 0.25);
  transition: all 0.25s ease;
}

.ceo-toggle-btn i {
  font-size: 18px;
  line-height: 1;
}

.ceo-toggle-btn:hover {
  background: linear-gradient(90deg, #5d0e02 0%, #f43939 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(225, 110, 30, 0.35);
}

/* ====== Contenedor del desplegable ====== */
.ceo-details {
  background: #f8f8f8;
  border: 1px solid #dedede;
  border-radius: 10px;
  padding: 20px;
  margin-top: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  max-width: 700px;
}

/* ====== Tarjeta individual de experiencia ====== */
.ceo-exp-card {
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  margin-bottom: 12px;
}

.ceo-exp-card:last-child {
  margin-bottom: 0;
}

/* header: puesto / empresa */
.ceo-exp-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
}

.ceo-exp-role {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1d;
  line-height: 1.4;
}

.ceo-exp-company {
  font-size: 14px;
  font-weight: 500;
  color: #d1701f;
  /* toque corporativo cálido */
  line-height: 1.4;
}

/* meta: fechas y ubicación */
.ceo-exp-meta {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.ceo-exp-sep {
  color: #999;
}

/* descripción */
.ceo-exp-desc p {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 6px;
}

.ceo-exp-desc p:last-child {
  margin-bottom: 0;
}

/* ====== Animación del desplegable ====== */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.2s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ====== Responsive tweaks ====== */
@media (max-width: 991px) {
  .ceo-section {
    text-align: center;
  }

  .ceo-content {
    margin-top: 30px;
  }

  .ceo-summary,
  .ceo-details {
    margin-left: auto;
    margin-right: auto;
  }

  .ceo-toggle-btn {
    margin-left: auto;
    margin-right: auto;
  }

  .ceo-exp-card {
    text-align: left;
  }
}
</style>
